import _extends from "babel-runtime/helpers/extends";
import _Set from "babel-runtime/core-js/set";
import _Array$from from "babel-runtime/core-js/array/from";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _Promise from "babel-runtime/core-js/promise";
import sysConfig from "../config/sysConfig";
import baseConfig from "../config/baseConfig";
import dict from "../tools/dict";
import oppService from "./opp-service";
import storge from "../tools/storage";
import definecfg from "../config/defineConfig.js";
import date from "../tools/date";
import csdcService from "./csdc-service";
import bizcfg from "../config/bizConfig.js";

function judgeData(res, resolve, reject) {
  if (res && res.Code && res.Code === "0") {
    resolve(res.Data || []);
  } else {
    var msg = res.Msg || "系统出错";
    reject(msg);
  }
}

export default {
  getAllBizData: function getAllBizData(params, busiCode) {
    var CUST_CODE = params.CUST_CODE,
        USER_TYPE = params.USER_TYPE,
        ID_TYPE = params.ID_TYPE,
        ID_CODE = params.ID_CODE;

    if (!CUST_CODE) {
      if (params.NEW_CUST_CODE) {
        CUST_CODE = params.NEW_CUST_CODE;
      } else {
        return _Promise.resolve([]);
      }
    }
    return sysConfig.$syscfg.K_Request("W0000313", {
      CUST_CODE: CUST_CODE,
      USER_TYPE: USER_TYPE,
      ID_TYPE: ID_TYPE,
      ID_CODE: ID_CODE,
      BUSI_CODE: busiCode,
      PROC_STATUS: "11,01"
    }, true).then(function (data) {
      if (data.Code == "0") {
        return data.Data;
      }
    });
  },
  getCustSysOpenJjtrdacctInfo: function getCustSysOpenJjtrdacctInfo(custCode) {
    return sysConfig.$syscfg.K_Request("W0000179", {
      CUST_CODE: custCode
    }).then(function (data) {
      if (data.Code == "0") {
        return data.Data;
      } else {
        throw "W0000137\u63A5\u53E3\u8C03\u7528\u5931\u8D25\uFF0C\u539F\u56E0\uFF1A" + data.Msg;
        return [];
      }
    });
  },

  getCustAgmtData: function getCustAgmtData(custCode, agmtType) {
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000138", {
        CUST_AGMT_TYPE: agmtType,
        CUST_CODE: custCode
      }).then(function (data) {
        resolve(data && data.Data && data.Data.length && data.Data || []);
      }).catch(function (data) {
        reject(data);
      });
    });
  },

  suitablyResult: function suitablyResult(basedata) {
    var that = this,
        busiCommParamArr = storge.$storage.getJsonLocal(definecfg.$definecfg.BUSI_COMM_PARAM),
        matchBizType = "";

    return _Promise.all([that.getCustMatchData(basedata.CUST_CODE, basedata.USER_TYPE, matchBizType, basedata.CUST_AGMT_TYPE, basedata.STKBD, basedata.TRDACCT_EXCLS, basedata)]).then(function (arr) {
      var dictArr = ["EXPECT_INCOME", "INVEST_LMT", "INVEST_PRO", {
        "BUSIRATING_LVL": "RISK_PROPRIGHT",
        "CHK_EXPECT_INCOME": "EXPECT_INCOME",
        "CHK_INVEST_LMT": "INVEST_LMT",
        "CHK_INVEST_PRO": "INVEST_PRO",

        "RATING_LVL_PROP": "RATING_LVL"
      }];
      return _Promise.all([dict.transformDict(arr[0].INVEST_PRO, dictArr), dict.transformDict(arr[0].INVEST_LMT, dictArr)]).then(function (res) {
        var newData = { INVEST_PRO: res[0], INVEST_LMT: res[1] };
        consoleLog("适当性匹配的结果", newData);
        return newData;
      });
    });
  },
  getCustMatchData: function getCustMatchData(custCode, userType, matchBizType, custAgmtType, stkbd, trdacctExcls, custBaseData) {
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000101", {
        CUST_CODE: custCode,
        USER_TYPE: userType,
        MATCH_BIZ_TYPE: matchBizType,
        CUST_AGMT_TYPE: custAgmtType,
        STKBD: stkbd,
        TRDACCT_EXCLS: trdacctExcls,
        BUSI_CODE: custBaseData.BUSI_CODE,

        F_CUST_ORG_CODE: custBaseData.F_CUST_ORG_CODE || custBaseData.ORG_CODE
      }).then(function (data) {
        if (data.Code == "0") {
          resolve(data.Data && data.Data[0] || {});
        } else {
          reject(_Object$assign(data, {
            message: data.Msg
          }));
        }
      }).catch(function (error) {
        reject(_Object$assign(error, {
          message: error.Msg
        }));
      });
    });
  },
  assembleCustMatchData: function assembleCustMatchData(params, custSurveyData, noGetCache) {
    var _this = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var that, matchObjFromCache, busiCommParamArr, isBusiCodeChange, investProObj, investLmtObj, busiData, ratingData, suitablyResult, customerInfo, IS_PROF_FLAG, STANDARD_PROPER;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this, matchObjFromCache = storge.$storage.getJsonLocal(definecfg.$definecfg.MATCH_OBJ);

              if (_.isEmpty(matchObjFromCache)) {
                matchObjFromCache = params.MATCH_OBJ_CACHE || {};
              }

              if (!(!_.isEmpty(matchObjFromCache) && noGetCache != "1")) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", matchObjFromCache);

            case 4:
              busiCommParamArr = storge.$storage.getJsonLocal(definecfg.$definecfg.BUSI_COMM_PARAM) || [];

              if (!params.BUSI_CODE) {
                _context.next = 14;
                break;
              }

              isBusiCodeChange = _.filter(busiCommParamArr, function (item) {
                return item.BUSI_CODE == params.BUSI_CODE;
              });

              if (!(isBusiCodeChange.length === 0)) {
                _context.next = 14;
                break;
              }

              vm.$storage.removeLocal(vm.$definecfg.BUSI_COMM_PARAM);
              vm.$storage.removeLocal(vm.$definecfg.BUSI_COMM_PARAM_OBJS);
              consoleLog("重新获取业务公参");
              _context.next = 13;
              return oppService.getBusiCommonParams(params.BUSI_CODE);

            case 13:
              busiCommParamArr = _context.sent;

            case 14:
              investProObj = {};
              investLmtObj = {};
              busiData = storge.$storage.getJsonSession(definecfg.$definecfg.BUSI_INFO) || {};
              _context.t1 = params.CUST_CODE;

              if (!_context.t1) {
                _context.next = 22;
                break;
              }

              _context.next = 21;
              return that.getCustSurveyData(params);

            case 21:
              _context.t1 = _context.sent;

            case 22:
              _context.t0 = _context.t1;

              if (_context.t0) {
                _context.next = 25;
                break;
              }

              _context.t0 = custSurveyData;

            case 25:
              ratingData = _context.t0;
              _context.t3 = params.BUSI_CODE;

              if (!_context.t3) {
                _context.next = 31;
                break;
              }

              _context.next = 30;
              return that.suitablyResult(params);

            case 30:
              _context.t3 = _context.sent;

            case 31:
              _context.t2 = _context.t3;

              if (_context.t2) {
                _context.next = 34;
                break;
              }

              _context.t2 = params;

            case 34:
              suitablyResult = _context.t2;
              customerInfo = storge.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO);
              IS_PROF_FLAG = _.includes(["10", "11", "12"], customerInfo.PROF_INVESTOR_SOURCE);
              STANDARD_PROPER = {
                PROPER_BIZ_RISK_LVL: oppService.getBusiCommonParamsByCode(busiCommParamArr, "PROPER_BIZ_RISK_LVL") || "",
                PROPER_RISK_SURVEY_LVL: oppService.getBusiCommonParamsByCode(busiCommParamArr, "PROPER_RISK_SURVEY_LVL") || "",
                PROPER_INVEST_PRO: oppService.getBusiCommonParamsByCode(busiCommParamArr, "PROPER_INVEST_PRO") || "",
                PROPER_INVEST_LMT: oppService.getBusiCommonParamsByCode(busiCommParamArr, "PROPER_INVEST_LMT") || "",

                CHECK_PROPER_RESULT: oppService.getBusiCommonParamsByCode(busiCommParamArr, "CHECK_PROPER_RESULT") || ""
              };

              if (suitablyResult.INVEST_PRO) {
                investProObj = {
                  INVEST_PRO_ERROR_CODE: suitablyResult.INVEST_PRO.ERROR_CODE || "",
                  INVEST_PRO_ERROR_MSG: suitablyResult.INVEST_PRO.ERROR_MSG || "",
                  INVEST_PRO: suitablyResult.INVEST_PRO.INVEST_PRO || suitablyResult.INVEST_PRO,
                  INVEST_PRO_TEXT: suitablyResult.INVEST_PRO.INVEST_PRO_TEXT || suitablyResult.INVEST_PRO_TEXT
                };
              }

              if (suitablyResult.INVEST_LMT) {
                investLmtObj = {
                  INVEST_LMT_ERROR_CODE: suitablyResult.INVEST_LMT.ERROR_CODE || "",
                  INVEST_LMT_ERROR_MSG: suitablyResult.INVEST_LMT.ERROR_MSG || "",
                  INVEST_LMT: suitablyResult.INVEST_LMT.INVEST_LMT || ""
                };
              }
              return _context.abrupt("return", dict.transformDict(STANDARD_PROPER, {
                "PROPER_INVEST_PRO": "INVEST_PRO",
                "PROPER_INVEST_LMT": "INVEST_LMT",
                "PROPER_BIZ_RISK_LVL": "OPP_BIZ_RISK_LVL"
              }).then(function (standardInvestorTrans) {
                var matchObj = _Object$assign({}, {}, ratingData, investProObj, investLmtObj, standardInvestorTrans),
                    errorMsg = matchObj.isExternalCust ? "" : that.getErrorMsg(matchObj);
                consoleLog("11适当性匹配结果errorMsg=", errorMsg);
                var isMatch = matchObj.IS_MATCH || (!!errorMsg ? "1" : "0");
                consoleLog("222适当性匹配结果isMatch=", isMatch);
                return _Object$assign({}, matchObj, {
                  MATCH_RESULT: isMatch,
                  MATCH_FLAG: isMatch,
                  IS_MATCH: isMatch,
                  PROPER_MATCHING_RESULTS: isMatch == "0" ? "true" : ""
                });
              }));

            case 41:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  getErrorMsg: function getErrorMsg(PROPER_DATA) {
    var errorMsg = "",
        that = this,
        warningCode = ["-900103"];
    that.forbidFlag = !!PROPER_DATA.ERROR_CODE && warningCode.indexOf(PROPER_DATA.ERROR_CODE) === -1;

    if (PROPER_DATA.ERROR_CODE && "" !== PROPER_DATA.ERROR_CODE) {
      errorMsg = PROPER_DATA.ERROR_MSG + "，";
    }

    if (PROPER_DATA.INVEST_PRO_ERROR_CODE && "" !== PROPER_DATA.INVEST_PRO_ERROR_CODE) {
      errorMsg += PROPER_DATA.INVEST_PRO_ERROR_MSG + "，";
    }

    if (PROPER_DATA.INVEST_LMT_ERROR_CODE && "" !== PROPER_DATA.INVEST_LMT_ERROR_CODE) {
      errorMsg += PROPER_DATA.INVEST_LMT_ERROR_MSG + "，";
    }
    return errorMsg;
  },

  getTradeOtherInfoData: function getTradeOtherInfoData(custCode, intOrg, cuacctCode, bizType, subBizType, param) {
    return sysConfig.$syscfg.K_Request("W0000136", {
      GENRPCLBMNO: "L5450120",
      CUST_CODE: custCode,
      INT_ORG: intOrg,
      CUACCT_CODE: cuacctCode,
      BIZ_TYPE: bizType,
      SUBBIZ_TYPE: subBizType,
      noProcess: param.noProcess || false
    }).then(function (data) {
      return data && data.Data[0] && data.Data[0].SUITABLEASSET || "0";
    });
  },
  getAvgFundAssetData: function getAvgFundAssetData(custCode, params) {
    params = params || {};
    return sysConfig.$syscfg.K_Request("W0000237", _Object$assign({
      CUST_CODE: custCode
    }), params).then(function (data) {
      if (data.Code != "0") {
        throw data.Msg;
      }
      return data && data.Data[0] && data.Data[0] || null;
    });
  },
  getSurveySn: function getSurveySn(params) {
    var busiCode = params.BUSI_CODE || "",
        userType = params.USER_TYPE || "";

    var surver_sn_key = userType == "0" ? "PERSON_SURVEY_SN" : "ORG_SURVEY_SN";
    var surver_sn_value = oppService.getBusiCommonParamsFromCacheObjs[surver_sn_key];
    if (surver_sn_value) {
      return surver_sn_value;
    }
    return oppService.getBusiCommonParams(busiCode, surver_sn_key).then(function (surveySn) {
      return surveySn;
    });
  },

  runCsdcValidate: function runCsdcValidate(params) {
    var _this2 = this;

    return sysConfig.$syscfg.getSysConfig("IS_MUST_CSDC_VALIDATE").then(function (data) {
      if (data.Code == 0) {
        if (data.Data[0] && data.Data[0].PAR_VAL == "0") {
          return {
            result: [],
            flag: true
          };
        } else {
          var that = _this2;
          return that.CsdcValidate(params);
        }
      } else {
        throw data.Msg;
      }
    });
  },
  CsdcValidate: function CsdcValidate(params) {
    return sysConfig.$syscfg.K_Request("W0000105", {
      OPERATOR_TYPE: "0",
      ACCTBIZ_CLS: "02",
      CHK_STATUS: "2",
      F_CUST_ORG_CODE: params.F_CUST_ORG_CODE || params.INT_ORG || params.ORG_CODE,
      ID_CODE: params.ID_CODE,
      ID_TYPE: params.ID_TYPE,
      CUST_FNAME: params.CUST_FNAME,
      ACCTBIZ_EXCODE: "23"
    }).then(function (res) {
      if (res.Code == "0") {
        var data = res.Data[0];
        if (data && data.ISSAMEFLAG == "true") {
          return {
            result: [],
            flag: true
          };
        } else {
          return {
            result: [],
            flag: false
          };
        }
      } else {
        return {
          result: [],
          flag: false
        };
      }
    }).catch(function (err) {
      return {
        result: [],
        flag: false
      };
    });
  },

  runPoliceValidate: function runPoliceValidate(param, forceRun) {
    var flag = oppService.getSysCommonParamsFromCacheObjs("POLICE_VALIDATE");
    var policeIdTypes = JSON.parse(oppService.getSysCommonParamsFromCacheObjs("POLICE_READ_VALI_ID_TYPE") || "{\"READ_ID_TYPE\":\"00,0s\",\"POLICE_ID_TYPE\":\"00,0J,0b,0c,0d\"}").POLICE_ID_TYPE;
    var policeIdTypeArr = policeIdTypes && policeIdTypes.split(",") || [];
    if (forceRun || flag == "1" && policeIdTypeArr.indexOf(param.ID_TYPE) > -1) {
      consoleLog("进入了公安联网校验的方法内部");
      param.ID_TYPE = param.ID_TYPE == "0J" ? "00" : param.ID_TYPE;
      var that = this,
          inputObj = _.assign({}, param),
          sexText = void 0;
      if (param.SEX) {
        return dict.transformDict(param, "SEX").then(function (param) {
          sexText = param.SEX_TEXT;
          sexText && (inputObj.SEX = sexText.charAt(0));
          return that.policeValidate(inputObj, param, sexText);
        });
      } else {
        return that.policeValidate(inputObj, param, sexText);
      }
    } else {
      consoleLog("内部方法，跳过公安联网校验");
      return _Promise.resolve({
        result: [],
        flag: true
      });
    }
  },
  policeValidate: function policeValidate(inputObj, param, sexText) {
    if (!inputObj || !inputObj.ID_TYPE || !inputObj.USER_NAME || !inputObj.ID_CODE) {
      vm.alert("公安联网失败，客户三要素不能为空！");
      return _Promise.resolve({
        result: [{
          output: "公安联网失败，客户三要素不能为空！",
          input: "公安联网失败，客户三要素不能为空！"
        }, {
          output: "公安联网失败，客户三要素不能为空！",
          input: "公安联网失败，客户三要素不能为空！"
        }],
        flag: false
      });
    }
    return sysConfig.$syscfg.K_Request("W0000095", inputObj).then(function (data) {
      if (data.Code != "0") {
        throw _JSON$stringify(data);
      }
      if (!data.Data || !data.Data.length) {
        return {
          result: [],
          flag: true
        };
      }
      var output = data.Data && data.Data[0],
          keyArr = [{
        name: "证件号码",
        key: "ID_CODE"
      }, {
        name: "姓名",
        key: "USER_NAME"
      }],
          tmpArr = [],
          flag = true;

      param.SEX && keyArr.push({
        name: "性别",
        key: "SEX"
      });
      param.BIRTHDAY && keyArr.push({
        name: "出生日期",
        key: "BIRTHDAY"
      });
      consoleLog("公安联网校验的,返回的结果IS_SUCCESS_FLAG=" + output.IS_SUCCESS_FLAG);

      _.chain(keyArr).each(function (obj) {
        var key = obj.key,
            inputStr = inputObj[key],
            outputStr = "ID_CODE" === key ? output[key + "_CHKRLT"] == "一致" ? inputObj[key] : output[key + "_CHKRLT"] : output[key + "_CHKRLT"].replace(/-/g, ""),
            isEqual = inputStr === outputStr;

        if (!isEqual) {
          flag = false;
        }

        tmpArr.push({
          key: key,
          name: obj.name,
          input: inputStr,
          output: outputStr,
          flag: isEqual
        });
      }).value();
      return {
        result: tmpArr,
        policeImgData: output.IMG_DATA || "",
        flag: output && output.IS_SUCCESS_FLAG === "1",
        policeLogId: output && output.LOG_ID
      };
    });
  },
  W0000134: function W0000134(param) {
    return sysConfig.$syscfg.K_Request("W0000134", param).then(function (res) {
      return !!res.Data.length;
    });
  },
  W0000135: function W0000135(param) {
    return sysConfig.$syscfg.K_Request("W0000135", param).then(function (res) {
      if (res.Code == "888888") {
        return true;
      }
      return !!res.Data.length;
    });
  },
  getKeyMonitorListByCustInfo: function getKeyMonitorListByCustInfo(param) {
    return sysConfig.$syscfg.K_Request("W0000119", {
      bex_codes: "KUAS_L1192258",
      USER_NAME: param.USER_NAME,
      ID_CODE: param.ID_CODE,
      ID_TYPE: param.ID_TYPE
    });
  },
  getAddSignAgreements: function getAddSignAgreements(param) {
    return sysConfig.$syscfg.K_Request("W0000119", {
      bex_codes: "YGT_A1200012",
      CUST_CODE: param.CUST_CODE || "0",
      USER_NAME: param.USER_NAME,
      ID_CODE: param.ID_CODE,
      ID_TYPE: param.ID_TYPE,
      CUST_AGMT_TYPE: param.CUST_AGMT_TYPE,
      INT_ORG: param.ORG_CODE
    });
  },
  W0000201: function W0000201(param) {
    return sysConfig.$syscfg.K_Request("W0000201", param).then(function (data) {
      if (data.Code == "0") {
        return true;
      } else {
        throw "\u7CFB\u7EDF\u8C03\u7528\u8D26\u6237\u7CFB\u7EDF\u63A5\u53E3L1102335\u7559\u75D5\u5DF2\u63D0\u793A\u5BA2\u6237\u5931\u8D25,\u539F\u56E0\uFF1A" + data.Msg;
        return false;
      }
    });
  },
  getCustFundInfo: function getCustFundInfo(custCode) {
    return sysConfig.$syscfg.K_Request("W0000191", {
      CUST_CODE: custCode,
      USER_CODE: custCode
    }).then(function (data) {
      if (data.Code == "0") {
        return data.Data && data.Data || [];
      } else {
        throw "获取用户资金账户信息，原因：" + data.Msg;
        return [];
      }
    });
  },
  getCustTaxInfo: function getCustTaxInfo(custCode, userType) {
    return sysConfig.$syscfg.K_Request("W0000204", {
      CUST_CODE: custCode,
      USER_TYPE: userType
    }).then(function (data) {
      if (data.Code == "0") {
        return data.Data && data.Data || [];
      } else {
        throw "获取客户的涉税信息数据，原因：" + data.Msg;
        return [];
      }
    });
  },
  queryValidIDType: function queryValidIDType(USER_TYPE) {
    var params = {
      USER_TYPE: USER_TYPE
    };

    if (USER_TYPE == "1") {
      params.IS_PRODUCT_CUST = 0;
    }
    if (USER_TYPE == "2") {
      params.IS_PRODUCT_CUST = 1;
    }
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000209", params).then(function (res) {
        judgeData(res, resolve, reject);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  getNewCustCode: function getNewCustCode(intOrg) {
    var params = {
      INT_ORG: intOrg
    };
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000192", params).then(function (res) {
        judgeData(res, resolve, reject);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  getCustInvestPro: function getCustInvestPro(custCode) {
    var params = {
      CUST_CODE: custCode
    };
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000216", params).then(function (res) {
        judgeData(res, resolve, reject);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  getAgmtCfgData: function getAgmtCfgData(custCode) {
    var params = {
      CUST_CODE: custCode
    };
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000230", params).then(function (res) {
        judgeData(res, resolve, reject);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  getTradeOtherInfoData_new: function getTradeOtherInfoData_new(custCode, Lbm, paramsTpl) {
    var params = _.assign({
      CUST_CODE: custCode,
      GENRPCLBMNO: Lbm
    }, paramsTpl);
    return new _Promise(function (resolve, reject) {
      sysConfig.$syscfg.K_Request("W0000136", params).then(function (res) {
        judgeData(res, resolve, reject);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getNeeqAcctFlag: function getNeeqAcctFlag(params) {
    return new _Promise(function (resolve, reject) {
      if (_.isEmpty(params) || _.isEmpty(params.TRDACCT)) {
        reject("获取股转账户标识标记类型必须入参TRADACCT");
      }
      var customerInfo = storge.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO);
      var userInfo = JSON.parse(storge.$storage.getSession(definecfg.$definecfg.USER_INFO));
      var CSDC_ACCT_LIST = params.CSDC_ACCT_LIST || [];
      var TRDACCT = params.TRDACCT || "";
      csdcService.queryCSDCTime().then(function (isInCsdcTime) {
        if (isInCsdcTime === "true") {
          sysConfig.$syscfg.K_Request("W0000205", {
            INT_ORG: userInfo.ORG_CODE,
            TRDACCT: TRDACCT,
            CSDC_ACCT_LIST: CSDC_ACCT_LIST
          }).then(function (res) {
            var flag = res[0] && res[0][0] && res[0][0].RTN_ERR_CODE == "0000" && res[0][0].NEEQ_FLAG == "1" ? "1" : "0";
            resolve(flag);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          if (params.EXT_CUST_FLAG) {
            resolve("0");
            return;
          }
          sysConfig.$syscfg.K_Request("W0000226", {
            TRDACCT: TRDACCT
          }).then(function (res) {
            var flag = res[0] && res[0][0] && res[0][0].NEEQ_FLAG == "1" ? "1" : "0";
            resolve(flag);
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    });
  },

  getNeeqFlagForCsdc: function getNeeqFlagForCsdc(csdcTrdacctArr) {
    var trdacctData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var extCustFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var that = this;
    var proArray = [],
        proResultArr = [],
        resultObj = {
      GZ_TRDACCT_DATA: [],
      NEEQ_FLAG_FOR_CSDC: "0"
    };
    trdacctData = _Array$from(new _Set(trdacctData));
    _.each(trdacctData, function (trdacct) {
      proArray.push(new _Promise(function (resolve, reject) {
        that.getNeeqAcctFlag({
          TRDACCT: trdacct,
          EXT_CUST_FLAG: extCustFlag,
          CSDC_ACCT_LIST: csdcTrdacctArr
        }).then(function (flag) {
          proResultArr.push({
            TRDACCT: trdacct,
            NEEQ_FLAG: flag
          });
          resolve();
        }).catch(function (error) {
          consoleLog(error);
          reject(error);
        });
      }));
    });
    return _Promise.all(proArray).then(function () {
      resultObj.GZ_TRDACCT_DATA = _.chain(proResultArr).filter(function (obj) {
        return obj.NEEQ_FLAG == "0";
      }).map(function (obj) {
        return obj.TRDACCT;
      }).value();

      resultObj.NEEQ_FLAG_FOR_CSDC = resultObj.GZ_TRDACCT_DATA.length ? "1" : "0";
      return resultObj;
    });
  },

  queryAssetsEx: function queryAssetsEx(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3227007",
      CUST_CODE: paramObj.CUST_CODE,
      TYPE: paramObj.TYPE,
      BUSI_CODE: paramObj.BUSI_CODE,
      DATA_SOURCES: paramObj.DATA_SOURCES,
      F_CUST_ORG_CODE: paramObj.F_CUST_ORG_CODE || paramObj.ORG_CODE
    }).then(function (data) {
      if (data && data.Code && data.Code == "0") {
        return data.Data;
      }
    });
  },
  getAllBankConfData: function getAllBankConfData(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000015",
      CURRENCY: param.CURRENCY,
      EXT_ORG: param.EXT_ORG,
      INT_ORG: param.INT_ORG,
      CUBSB_TRD_ID: param.CUBSB_TRD_ID || "19"
    }).then(function (data) {
      if (data && data.Code && data.Code == "0") {
        return data.Data;
      }
    });
  },

  getProFundsInfo: function getProFundsInfo(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3034405",
      CUST_CODE: paramObj.CUST_CODE
    }).then(function (data) {
      if (data.Code == "0") {
        return data.Data || [];
      } else {
        throw "获取产品份额接口（OTC）调取失败，原因：" + data.Msg;
      }
    });
  },

  getFundsAccountStatus: function getFundsAccountStatus(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000025",
      CUST_CODE: paramObj.CUST_CODE,
      TA_CODE: paramObj.TA_CODE || ""
    }).then(function (data) {
      if (data.Code == "0") {
        return data.Data || [];
      } else {
        throw "查询基金账户状态 (集中交易)接口调取失败，原因：" + data.Msg;
      }
    });
  },
  isMutiplTel: function isMutiplTel(num, type, custInfo) {
    consoleLog("手机号码是否重复使用校验Y3000922接口调用了，入参：", "TEL:" + num + ",TEL_TYPE:" + type + ",CUST_CODE:" + (custInfo.CUST_CODE || custInfo.NEW_CUST_CODE));
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000922",
      TEL: num,
      TEL_TYPE: type,
      CUST_CODE: custInfo.CUST_CODE || custInfo.NEW_CUST_CODE
    }).then(function (res) {
      var data = _.chain(_.get(res, "Data[0].UP_ANS_COMM_DATA[0]", [])).filter(function (v) {
        return v.ID_CODE !== custInfo.ID_CODE && v.USER_NAME !== custInfo.CUST_FNAME;
      }).uniqBy("ID_CODE", "USER_NAME").value();
      return data || [];
    });
  },
  otherTelMobileCheck: function otherTelMobileCheck(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3001002",
      OPERATOR_TYPE: "0",
      ACCTBIZ_EXCODE: "24",
      CHK_STATUS: param.CHK_STATUS || "2",
      ACCTBIZ_CLS: param.ACCTBIZ_CLS,
      CUST_CODE: param.CUST_CODE,
      CUST_FNAME: param.CUST_FNAME,
      ID_TYPE: param.ID_TYPE,
      ID_CODE: param.ID_CODE,
      YMT_CODE: param.YMT_CODE,
      USER_TYPE: param.USER_TYPE,
      TRDACCT: param.TRDACCT,
      ACCT_TYPE: param.ACCT_TYPE,
      TA_CODE: param.TA_CODE,
      OF_ACCT: param.OF_ACCT,
      MOBILE_TEL: param.MOBILE_TEL,
      F_CUST_ORG_CODE: param.F_CUST_ORG_CODE
    }, true, true);
  },

  getExtInstData: function getExtInstData(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3002303",
      IS_CHECK: paramObj.IS_CHECK,
      INT_ORG: paramObj.INT_ORG,
      USER_ROLE: "2"
    }, true);
  },

  getAccountForeignCurrency: function getAccountForeignCurrency(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000066",
      CUST_CODE: paramObj.CUST_CODE
    }, true);
  },

  getRemark: function getRemark(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000040",
      CUST_CODE: paramObj.CUST_CODE
    }, true);
  },

  queryAvailableBalance: function queryAvailableBalance(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3036004",
      ACCOUNT: paramObj.CUACCT_CODE,
      CUST_CODE: paramObj.CUST_CODE,
      USER_CODE: paramObj.USER_CODE
    }, true);
  },

  getAssetLimit: function getAssetLimit(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000047",
      CUST_CODE: paramObj.CUST_CODE,
      ACCOUNT: paramObj.ACCOUNT
    }, true);
  },
  getNewProFundsInfo: function getNewProFundsInfo(CUST_CODE) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3032419",
      CUST_CODE: CUST_CODE,
      USER_ROLE: "2"
    }).then(function (data) {
      return data.Data || [];
    });
  },
  getCustAgmtInfo: function getCustAgmtInfo(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3006014",
      CUST_FNAME: param.CUST_FNAME,
      ID_TYPE: param.ID_TYPE,
      ID_CODE: param.ID_CODE,
      CUST_AGMT_TYPE: param.CUST_AGMT_TYPE || "",
      REMOTE_SYS: param.REMOTE_SYS || "",
      CUACCT_CODE: param.CUACCT_CODE || "",
      STKBD: param.STKBD || "",
      TRDACCT: param.TRDACCT || ""
    }, true).then(function (data) {
      return data.Data || [];
    });
  },
  queryCustAgmtList: function queryCustAgmtList(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000012",
      CUST_CODE: param.CUST_CODE,
      CUST_AGMT_TYPE: param.CUST_AGMT_TYPE || "",
      REMOTE_SYS: param.REMOTE_SYS || "",
      CUACCT_CODE: param.CUACCT_CODE || "",
      STKBD: param.STKBD || "",
      TRDACCT: param.TRDACCT || ""
    }, true).then(function (data) {
      return data.Data || [];
    });
  },
  getBranchBank: function getBranchBank(param) {
    return sysConfig.$syscfg.K_Request("Y1002227", {
      BANK_CODE: param.BANK_CODE,
      ORG_CODE: param.ORG_CODE
    }).then(function (data) {
      return data.Data || [];
    });
  },
  getBankManage: function getBankManage(BANK_CODE) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y1000268",
      BANK_CODE: BANK_CODE
    }).then(function (res) {
      return res.Data[0];
    });
  },
  getCustAmlLvlAccess: function getCustAmlLvlAccess(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS300520",
      IS_OPEN_BUSI: "1",
      CUST_FNAME: param.CUST_FNAME,
      ID_TYPE: param.ID_TYPE,
      ID_CODE: param.ID_CODE,
      USER_TYPE: param.USER_TYPE
    });
  },
  checkCustInfo: function checkCustInfo(param, ignoreError) {
    return sysConfig.$syscfg.K_Request("F0000000", _extends({
      SERVICE_CODE: "QS010170"
    }, param), ignoreError || false).then(function (data) {
      return data;
    }).catch(function (err) {
      consoleLog("checkCustInfo ECIF校验出错", err);
      return [];
    });
  },
  getBusinessMate: function getBusinessMate(param) {
    return sysConfig.$syscfg.K_Request("Y3000983", _extends({}, param)).then(function (res) {
      return res.Data;
    }).catch(function (err) {
      consoleLog(err);
    });
  },
  getCustRzrqOrGpqqFlag: function getCustRzrqOrGpqqFlag(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000045",
      F_FUNCTION: "980105012",
      p_gnbh: "980105012",
      QUERY_MODE: "QUERY",
      USER_CODE: param.CUST_CODE
    }, true).then(function (data) {
      var custIsRzrqOrGpqqFlag = "0";
      if (data && data.Data && data.Data.length) {
        _.each(data.Data, function (item) {
          if (item.CUACCT_ATTR == "1" || item.CUACCT_ATTR == "3") {
            custIsRzrqOrGpqqFlag = "1";
          }
        });
      }
      return custIsRzrqOrGpqqFlag;
    });
  },
  getYztAllCustCode: function getYztAllCustCode(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y1000411",
      CUST_FNAME: param.CUST_FNAME,
      ID_TYPE: param.ID_TYPE,
      ID_CODE: param.ID_CODE,
      USER_TYPE: param.USER_TYPE,
      IS_FILTER: param.IS_FILTER
    }).then(function (res) {
      return res && res.Data || [];
    }).catch(function (err) {
      consoleLog("getYztAllCustCode 查询客户在一站通系统内的所有客户号报错：" + err);
      return [];
    });
  },
  getInvestorType: function getInvestorType(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3002705",
      CUST_CODE: param.CUST_CODE
    }).then(function (res) {
      return res && res.Data && res.Data[0] || {};
    }).catch(function (err) {
      consoleLog("getInvestorType 获取投资者适当性信息报错：" + err);
      return {};
    });
  },
  getCustRegAcctData: function getCustRegAcctData(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3034409",
      USER_TYPE: param.USER_TYPE,
      CUST_CODE: param.CUST_CODE,
      CUST_FNAME: param.CUST_FNAME,
      ID_TYPE: param.ID_TYPE,
      ID_CODE: param.ID_CODE
    }).then(function (res) {
      var acctData = _.filter(res && res.Data || [], function (item) {
        return item.ACCT_STAT !== "9";
      });
      return acctData;
    }).catch(function (err) {
      consoleLog("getCustRegAcctData-查询客户登记账号：" + err);
      return [];
    });
  },
  getCustTrdacct: function getCustTrdacct(paramObj) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y2001050",
      CUST_CODE: paramObj.CUST_CODE,
      CUSTOMER: paramObj.CUST_CODE
    }).then(function (res) {
      return res && res.Data || [];
    }).catch(function (err) {
      consoleLog("getCustTrdacct-查询客户证券账户出错：" + err);
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/service/cust-service.js
// module id = 149
// module chunks = 2